/**
 * Atalhos leves do piso para o time (DM). Sem fila, agenda ou inbox pessoais.
 */

export function sanitizeCockpitPath(raw) {
  const value = String(raw || "").trim();
  if (!value.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return null;
  if (value.includes("://") || value.includes("\\")) return null;
  if (value.startsWith("/video")) return null;
  return value.slice(0, 2048);
}

/** Abre o chat da equipe em outra aba e deixa o piso aberto. */
export function openCockpitPathFromVideo(path) {
  const clean = sanitizeCockpitPath(path);
  if (!clean || typeof window === "undefined") return { opened: null };
  try {
    const tab = window.open(clean, "_blank", "noopener,noreferrer");
    if (tab) {
      try {
        tab.opener = null;
      } catch {
        /* ignore */
      }
    }
    return { opened: "tab" };
  } catch {
    /* popup blocked */
  }
  return { opened: null };
}

export function resolveOfficeLifePaths(returnPath = "") {
  const raw = String(returnPath || "");
  const popup = raw.startsWith("/popup-equipe");
  const base = popup ? "/popup-equipe" : "/equipe";
  return {
    chat: base,
    chatSpace: (spaceId) => {
      const id = Number(spaceId);
      return Number.isFinite(id) && id > 0 ? `${base}/${id}` : base;
    },
  };
}

export function userIdFromAgentIdentity(identity) {
  const m = /^agent_(\d+)(?:_|$)/i.exec(String(identity || "").trim());
  if (!m) return null;
  const id = Number(m[1]);
  return Number.isFinite(id) && id > 0 ? id : null;
}
